import { type ReactNode } from 'react';
import { Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

interface Props {
    headers: ReactNode;
    children: ReactNode;
}

const SalaryDataTable = ({ headers, children }: Props) => (
    <Paper>
        <Table size="small">
            <TableHead>
                <TableRow>
                    {headers}
                    <TableCell align="right" />
                </TableRow>
            </TableHead>
            <TableBody>{children}</TableBody>
        </Table>
    </Paper>
);

export default SalaryDataTable;
